import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62b399c6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=62b399c6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b399c6')) {
      api.createRecord('62b399c6', component.options)
    } else {
      api.reload('62b399c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62b399c6", function () {
      api.rerender('62b399c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner-store/index.vue"
export default component.exports